import { render, staticRenderFns } from "./DoughnutProfileStrength.vue?vue&type=template&id=754adba7"
import script from "./DoughnutProfileStrength.vue?vue&type=script&lang=js"
export * from "./DoughnutProfileStrength.vue?vue&type=script&lang=js"
import style0 from "./DoughnutProfileStrength.vue?vue&type=style&index=0&id=754adba7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports